import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import Slide1 from "../../images/location/atlanta/Slide1.png";
import Slide2 from "../../images/location/atlanta/Slide2.png";
import Slide3 from "../../images/location/atlanta/Slide3.png";
import Slide4 from "../../images/location/atlanta/Slide4.png";
import Slide5 from "../../images/location/atlanta/Slide5.png";
import Slide6 from "../../images/location/atlanta/Slide6.png";
import Slide7 from "../../images/location/atlanta/Slide7.png";
import {LazyLoadImage} from "react-lazy-load-image-component";


const responsive = {
    superLargeDesktop: {
        breakpoint: {max: 4000, min: 1600},
        items: 2
    },
    desktop: {
        breakpoint: {max: 1599, min: 1400},
        items: 1
    },
    tabletlandscape: {
        breakpoint: {max: 1399, min: 1200},
        items: 1
    },
    tablet: {
        breakpoint: {max: 1199, min: 667},
        items: 2
    },
    mobile: {
        breakpoint: {max: 666, min: 0},
        items: 1
    }
};


function Caseslider(props) {
    return (
        <div className="services_buildapp p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <div className="example" data-text="Stories">
                            <h2>Our Efforts Lead to Success Stories of Businesses</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <p>TekRevol is committed to the success of the business world with its cutting-edge mobile app development services. Having a fully functional and seamless application is the need of the time for any organization. We have businesses on different scales to uplift their online presence resulting in great outcomes with continuous growth. There are many startups that our mobile app developers Seattle facilitated with top-notch mobile app products making them the market leader in a short period. It's all the result of our commitment to revolutionize beside the evolution of technology.</p>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
                        <Carousel responsive={responsive} infinite={true} autoPlay={true} autoPlaySpeed={5000}
                                  arrows={true} className="carousel_featured">

                            <div className="featured_item">
                                <div className="Case-slide">
                                    <div className="Case-slide_img">
                                        <LazyLoadImage
                                            src={Slide1}
                                            effect="blur" alt="Tab_01" className="img-fluid"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="featured_item">

                                <div className="Case-slide">
                                    <div className="Case-slide_img">
                                        <LazyLoadImage
                                            src={Slide2}
                                            effect="blur" alt="Tab_01" className="img-fluid "
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="featured_item">
                                <div className="Case-slide">
                                    <div className="Case-slide_img">
                                        <LazyLoadImage
                                            src={Slide3}
                                            effect="blur" alt="Tab_01" className="img-fluid"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="featured_item">
                                <div className="Case-slide">
                                    <div className="Case-slide_img">
                                        <LazyLoadImage
                                            src={Slide4}
                                            effect="blur" alt="Tab_01" className="img-fluid"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="featured_item">
                                <div className="Case-slide">
                                    <div className="Case-slide_img">
                                        <LazyLoadImage
                                            src={Slide5}
                                            effect="blur" alt="Tab_01" className="img-fluid"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="featured_item">
                                <div className="Case-slide">
                                    <div className="Case-slide_img">
                                        <LazyLoadImage
                                            src={Slide6}
                                            effect="blur" alt="Tab_01" className="img-fluid"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="featured_item">
                                <div className="Case-slide">
                                    <div className="Case-slide_img">
                                        <LazyLoadImage
                                            src={Slide7}
                                            effect="blur" alt="Tab_01" className="img-fluid"
                                        />
                                    </div>
                                </div>
                            </div>
                        </Carousel>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Caseslider;